import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupApiModel, IdNameApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class GroupsService {
  private apiUrl = 'groups';
  public resetEmitter = new EventEmitter<void>();

  constructor(private http: HttpClientService) {}

  public get(): Observable<GroupApiModel[]> {
    return this.http.get<GroupApiModel[]>(`${this.apiUrl}/get-list`);
  }

  public add(item: GroupApiModel): Observable<GroupApiModel> {
    return this.http.post<GroupApiModel>(`${this.apiUrl}/add`, item).pipe((response) => {
      this.resetEmitter.emit();
      return response;
    });
  }

  public update(item: GroupApiModel): Observable<GroupApiModel> {
    return this.http.put<GroupApiModel>(`${this.apiUrl}/update`, item).pipe((response) => {
      this.resetEmitter.emit();
      return response;
    });
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}`).pipe((response) => {
      this.resetEmitter.emit();
      return response;
    });
  }

  public getAvailableUsers(groupId: number): Observable<IdNameApiModel<string>[]> {
    return this.http.get<IdNameApiModel<string>[]>(`${this.apiUrl}/${groupId}/users/available`);
  }

  public addUser(groupId: number, userId: string): Observable<GroupApiModel> {
    const params = {
      groupId: groupId.toString(),
      userId: userId
    };
    return this.http
      .post<GroupApiModel>(`${this.apiUrl}/${groupId}/users/${userId}/add`, { params: params })
      .pipe((response) => {
        this.resetEmitter.emit();
        return response;
      });
  }

  public deleteUser(groupId: number, userId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${groupId}/users/${userId}/delete`).pipe((response) => {
      this.resetEmitter.emit();
      return response;
    });
  }
}
